export enum OnAccessType {
  EDIT_MODE = 'EDIT_MODE',
  VIEW_MODE = 'VIEW_MODE',
}
